<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide"

export default {
  props: {
    horizontal: { type: Boolean, default: false },
    options: { type: Object, default: null },
  },

  data: () => ({
    setOptions: {
      horizontal: {
        rewind: false,
        autoplay: false,
        arrows: true,
        focus: 'left',
        gap: '1.5rem',
        fixedWidth: '238px',
        pagination: false,
        trimSpace: 'move',
        padding: {
          left: 15,
          right: 15,
        }
      }
    },

    defaultOptions: {
      rewind: true,
      loop: true,
      focus: 'center',
      arrows: false,
      autoplay: true,
      interval: 8000,
    }
  }),

  computed: {
    computedOptions () {
      let options = { ...this.defaultOptions }

      if (this.horizontal) {
        options = { ...this.setOptions.horizontal, ...this.options }
      }

      return options
    }
  },

  methods: {
    ready () {
      this.$nextTick(() => {
        const ref = this.$refs.slide
        const screen = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        const container = ref.$el.querySelector('.splide__list').offsetWidth

        ref.splide.options = {...this.computedOptions, arrows: this.computedOptions.arrows && container > screen }

        ref.remount()
      })
    }
  },

  render (createElement) {
    const items = this.$scopedSlots['default']()

    return createElement(
      Splide,
      {
        ref: 'slide',
        props: { options: this.computedOptions },
        on: { 'splide:mounted': this.ready }
      },
      items.map(item => createElement(SplideSlide, [item]))
    )
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/variables";
.img-carousel {
  width: auto;
  max-width: 100%;
  border-radius: 15px;
}

::v-deep .splide {
  &__slide {
    text-align: center;
  }

  &__pagination {
    &__page {
      width: 0.8125rem;
      height: 0.8125rem;
      opacity: 1;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      
      &.is-active {
        transform: scale(1);
        background: $fucsia300;
      }
    }

    @media (max-width: 550px) {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  ::v-deep .splide__arrow {
    border-radius: 36px;
    background: $orange600;

    opacity: 1;
    box-shadow: 0px 2.5rem4px rgba(0, 0, 0, 0.25), 5px 5px 30px rgba(0, 0, 0, 0.2);
    transform: translate(0, -50%);
  
    top: 50%;
    width: 68px;
    height: 36px;

    svg { fill: #fff; width: 50% }

    &--prev { left: 10px }
    &--next { right: 10px }

    &[disabled] { display: none }
  }
</style>
